import React, { Component } from 'react';
import DatePicker from '../../../components/DatePicker';
import moment from 'moment';

import './ReportDatePicker.scss';

class ReportDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: props.startDate,
      endDate: props.endDate,
      resetSelection: false,
    };
    this.handleStartDateSelection = this.handleStartDateSelection.bind(this);
    this.handleEndDateSelection = this.handleEndDateSelection.bind(this);
    this.handleResetSelection = this.handleResetSelection.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedProjectEvent != this.props.selectedProjectEvent && this.props.selectedProjectEvent == 'all') {
      this.setState({ startDate: null, endDate: null });
      this.handleResetSelection();
    } else if (prevProps.startDate != this.props.startDate || prevProps.endDate != this.props.endDate) {
      this.setState({ startDate: this.props.startDate, endDate: this.props.endDate });
      this.handleResetSelection();
    }
  }

  handleStartDateSelection(date) {
    const { handleDateSelection } = this.props;
    if (handleDateSelection) {
      handleDateSelection(date, 'start');
    }
    this.setState({ startDate: date });
  }

  handleEndDateSelection(date) {
    const { handleDateSelection } = this.props;
    if (handleDateSelection) {
      handleDateSelection(date, 'end');
    }
    this.setState({ endDate: date });
  }

  handleResetSelection() {
    this.setState({ resetSelection: !this.state.resetSelection });
  }

  render() {
    let startDate = (
      <div className="start-date-selector">
        <div className='start-date-label'>FROM</div>
        <div className="date-picker-container">
          <DatePicker
            selected={this.state.startDate}
            handleDateSelection={this.handleStartDateSelection}
            minDate={moment().startOf('year').subtract(1, 'y')}
            maxDate={moment()}
            placeHolderText={'MM/DD/YYYY'}
            width={92} 
            resetSelection={this.state.resetSelection}
            handleResetSelection={this.handleResetSelection}
            popperPlacement={'bottom-end'}
          />
        </div>
      </div>
    );

    let endDate = (
      <div className="end-date-selector">
        <div className='end-date-label'>TO</div>
        <div className="date-picker-container">
          <DatePicker
            selected={this.state.endDate}
            handleDateSelection={this.handleEndDateSelection}
            minDate={this.state.startDate ? this.state.startDate :
              moment().startOf('year').subtract(1, 'y')
            }
            maxDate={moment()}
            placeHolderText={'MM/DD/YYYY'}
            width={92} 
            resetSelection={this.state.resetSelection}    
            handleResetSelection={this.handleResetSelection}
            popperPlacement={'bottom-end'}
        />
        </div>
      </div>
    );

    let style = {};
    if (this.props.left) {
      //+2 for offset
      style.left = (this.props.left + 2) + 'px';
    }
    if (this.props.top) {
      style.top = this.props.top + 'px';
    }

    return(
      <div className='ReportDatePicker' style={style}>
        <p className='date-selector-header'>Date Range</p>
        <div className='date-selector-container' ref={el => { this.props.handleSetDatePickerRef(el); }}>
          { startDate }
          { endDate }
        </div>
      </div>
    );
  }
}

export default ReportDatePicker;



// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/ReportDatePicker/index.js